import React, { useState, useEffect } from 'react'
//Bibliotecas
import styled from 'styled-components';
//Componentes
import FlexContainer from '../../components/common/FlexContainer';
import CrearCurso from './components/CrearCurso';
import CursoCards from './components/CursoCards';
import Loader from '../../components/common/Loader';
//Servicios
import CursoService from '../../services/CursoService';

export default function Home() {

  //Estados
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(false);

  //Manipuladores
  const refreshCursos = () => {
    setLoading(true);
    CursoService.obtenerCursos().then(res => {
      setCursos(res);
      setLoading(false);
    })
  }

  useEffect(() => {
    refreshCursos();
    return () => {
    }
  }, [])

  return (

    <FlexContainer backgroundColor='transparent' minHeight='1000px' justifyContent={'top'}>
      {!loading &&
        <>
          <CrearCurso refresh={refreshCursos}></CrearCurso>
          <CursoCards cursos={cursos} refresh={refreshCursos}></CursoCards>
        </>
      }{loading &&
        <FlexContainer height='100vh' justifyContent='center' alignItems='center' backgroundColor='transparent'>
          <Message>Cargando</Message>
          <Loader></Loader>
        </FlexContainer>
      }
    </FlexContainer>
  )
}

const Message = styled.h1`
  color:var(--color-blanco);
`;  



